import { render, staticRenderFns } from "./QuickExtendDialog.vue?vue&type=template&id=d30c7256&lang=pug&"
import script from "./QuickExtendDialog.vue?vue&type=script&lang=ts&"
export * from "./QuickExtendDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports